export { default as execute3SPrimeCall } from './actions/execute3SPrimeCall';
